// @generated by protobuf-ts 2.9.4
// @generated from protobuf file "mlmbox/types/bonus.proto" (package "mlmbox.types", syntax proto3)
// tslint:disable
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message mlmbox.types.Bonus
 */
export interface Bonus {
}
/**
 * @generated from protobuf message mlmbox.types.Bonus.Kind
 */
export interface Bonus_Kind {
    /**
     * @generated from protobuf field: mlmbox.types.Bonus.Kind.Id kind_id = 1;
     */
    kindId: Bonus_Kind_Id;
}
/**
 * @generated from protobuf enum mlmbox.types.Bonus.Kind.Id
 */
export enum Bonus_Kind_Id {
    /**
     * @generated from protobuf enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,
    /**
     * @generated from protobuf enum value: GIFT = 1;
     */
    GIFT = 1,
    /**
     * @generated from protobuf enum value: BONUS_DIRECT = 2;
     */
    BONUS_DIRECT = 2,
    /**
     * @generated from protobuf enum value: BONUS_MATRIX = 3;
     */
    BONUS_MATRIX = 3,
    /**
     * @generated from protobuf enum value: BONUS_CARD_PARTNER_DAO = 4;
     */
    BONUS_CARD_PARTNER_DAO = 4,
    /**
     * @generated from protobuf enum value: BONUS_CARD_BONUS_HUNTER = 5;
     */
    BONUS_CARD_BONUS_HUNTER = 5,
    /**
     * @generated from protobuf enum value: BONUS_BINARY = 6;
     */
    BONUS_BINARY = 6,
    /**
     * @generated from protobuf enum value: BONUS_BINARY_MATCHING = 7;
     */
    BONUS_BINARY_MATCHING = 7,
    /**
     * @generated from protobuf enum value: BONUS_GAME_TOKEN_WEB3_PURCHASE_PERSONAL = 8;
     */
    BONUS_GAME_TOKEN_WEB3_PURCHASE_PERSONAL = 8,
    /**
     * @generated from protobuf enum value: BONUS_GAME_TOKEN_WEB3_PURCHASE_PARTNERS = 9;
     */
    BONUS_GAME_TOKEN_WEB3_PURCHASE_PARTNERS = 9,
    /**
     * @generated from protobuf enum value: BONUS_GAME_TOKEN_EXCHANGE_PERSONAL = 10;
     */
    BONUS_GAME_TOKEN_EXCHANGE_PERSONAL = 10,
    /**
     * @generated from protobuf enum value: BONUS_GAME_TOKEN_EXCHANGE_PARTNERS = 11;
     */
    BONUS_GAME_TOKEN_EXCHANGE_PARTNERS = 11,
    /**
     * @generated from protobuf enum value: BONUS_GAME_TOKEN_PROMOTION_TOP_MATRIX = 12;
     */
    BONUS_GAME_TOKEN_PROMOTION_TOP_MATRIX = 12,
    /**
     * @generated from protobuf enum value: BONUS_GAME_TOKEN_PROMOTION_BINARY = 13;
     */
    BONUS_GAME_TOKEN_PROMOTION_BINARY = 13,
    /**
     * @generated from protobuf enum value: BONUS_GAME_TOKEN_PROMOTION_CASHBACK = 14;
     */
    BONUS_GAME_TOKEN_PROMOTION_CASHBACK = 14,
    /**
     * @generated from protobuf enum value: BONUS_GIFT_SHOP_CARD_WITHDRAWAL = 15;
     */
    BONUS_GIFT_SHOP_CARD_WITHDRAWAL = 15
}
/**
 * @generated from protobuf message mlmbox.types.Bonus.LevelPercent
 */
export interface Bonus_LevelPercent {
    /**
     * @generated from protobuf field: uint32 level = 1;
     */
    level: number;
    /**
     * @generated from protobuf field: string percent = 2;
     */
    percent: string;
}
/**
 * @generated from protobuf message mlmbox.types.Bonus.Value
 */
export interface Bonus_Value {
    /**
     * @generated from protobuf field: mlmbox.types.Bonus.Kind.Id bonus_id = 1;
     */
    bonusId: Bonus_Kind_Id;
    /**
     * @generated from protobuf field: string earned_value = 2;
     */
    earnedValue: string;
}
/**
 * @generated from protobuf message mlmbox.types.Bonus.Value.Asset
 */
export interface Bonus_Value_Asset {
    /**
     * @generated from protobuf field: uint32 asset_id = 1;
     */
    assetId: number;
    /**
     * @generated from protobuf field: mlmbox.types.Bonus.Value value = 2;
     */
    value?: Bonus_Value;
}
/**
 * @generated from protobuf message mlmbox.types.Bonus.Summary
 */
export interface Bonus_Summary {
    /**
     * @generated from protobuf field: string earned_value = 1;
     */
    earnedValue: string;
    /**
     * @generated from protobuf field: repeated mlmbox.types.Bonus.Value values = 2;
     */
    values: Bonus_Value[];
}
/**
 * @generated from protobuf message mlmbox.types.Bonus.Summary.Asset
 */
export interface Bonus_Summary_Asset {
    /**
     * @generated from protobuf field: uint32 asset_id = 1;
     */
    assetId: number;
    /**
     * @generated from protobuf field: mlmbox.types.Bonus.Summary summary = 2;
     */
    summary?: Bonus_Summary;
}
// @generated message type with reflection information, may provide speed optimized methods
class Bonus$Type extends MessageType<Bonus> {
    constructor() {
        super("mlmbox.types.Bonus", []);
    }
    create(value?: PartialMessage<Bonus>): Bonus {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<Bonus>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Bonus): Bonus {
        return target ?? this.create();
    }
    internalBinaryWrite(message: Bonus, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Bonus
 */
export const Bonus = new Bonus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Bonus_Kind$Type extends MessageType<Bonus_Kind> {
    constructor() {
        super("mlmbox.types.Bonus.Kind", [
            { no: 1, name: "kind_id", kind: "enum", T: () => ["mlmbox.types.Bonus.Kind.Id", Bonus_Kind_Id] }
        ]);
    }
    create(value?: PartialMessage<Bonus_Kind>): Bonus_Kind {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.kindId = 0;
        if (value !== undefined)
            reflectionMergePartial<Bonus_Kind>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Bonus_Kind): Bonus_Kind {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* mlmbox.types.Bonus.Kind.Id kind_id */ 1:
                    message.kindId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Bonus_Kind, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* mlmbox.types.Bonus.Kind.Id kind_id = 1; */
        if (message.kindId !== 0)
            writer.tag(1, WireType.Varint).int32(message.kindId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Bonus.Kind
 */
export const Bonus_Kind = new Bonus_Kind$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Bonus_LevelPercent$Type extends MessageType<Bonus_LevelPercent> {
    constructor() {
        super("mlmbox.types.Bonus.LevelPercent", [
            { no: 1, name: "level", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "percent", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Bonus_LevelPercent>): Bonus_LevelPercent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.level = 0;
        message.percent = "";
        if (value !== undefined)
            reflectionMergePartial<Bonus_LevelPercent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Bonus_LevelPercent): Bonus_LevelPercent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 level */ 1:
                    message.level = reader.uint32();
                    break;
                case /* string percent */ 2:
                    message.percent = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Bonus_LevelPercent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 level = 1; */
        if (message.level !== 0)
            writer.tag(1, WireType.Varint).uint32(message.level);
        /* string percent = 2; */
        if (message.percent !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.percent);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Bonus.LevelPercent
 */
export const Bonus_LevelPercent = new Bonus_LevelPercent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Bonus_Value$Type extends MessageType<Bonus_Value> {
    constructor() {
        super("mlmbox.types.Bonus.Value", [
            { no: 1, name: "bonus_id", kind: "enum", T: () => ["mlmbox.types.Bonus.Kind.Id", Bonus_Kind_Id] },
            { no: 2, name: "earned_value", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Bonus_Value>): Bonus_Value {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.bonusId = 0;
        message.earnedValue = "";
        if (value !== undefined)
            reflectionMergePartial<Bonus_Value>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Bonus_Value): Bonus_Value {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* mlmbox.types.Bonus.Kind.Id bonus_id */ 1:
                    message.bonusId = reader.int32();
                    break;
                case /* string earned_value */ 2:
                    message.earnedValue = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Bonus_Value, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* mlmbox.types.Bonus.Kind.Id bonus_id = 1; */
        if (message.bonusId !== 0)
            writer.tag(1, WireType.Varint).int32(message.bonusId);
        /* string earned_value = 2; */
        if (message.earnedValue !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.earnedValue);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Bonus.Value
 */
export const Bonus_Value = new Bonus_Value$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Bonus_Value_Asset$Type extends MessageType<Bonus_Value_Asset> {
    constructor() {
        super("mlmbox.types.Bonus.Value.Asset", [
            { no: 1, name: "asset_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "value", kind: "message", T: () => Bonus_Value }
        ]);
    }
    create(value?: PartialMessage<Bonus_Value_Asset>): Bonus_Value_Asset {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.assetId = 0;
        if (value !== undefined)
            reflectionMergePartial<Bonus_Value_Asset>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Bonus_Value_Asset): Bonus_Value_Asset {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 asset_id */ 1:
                    message.assetId = reader.uint32();
                    break;
                case /* mlmbox.types.Bonus.Value value */ 2:
                    message.value = Bonus_Value.internalBinaryRead(reader, reader.uint32(), options, message.value);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Bonus_Value_Asset, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 asset_id = 1; */
        if (message.assetId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.assetId);
        /* mlmbox.types.Bonus.Value value = 2; */
        if (message.value)
            Bonus_Value.internalBinaryWrite(message.value, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Bonus.Value.Asset
 */
export const Bonus_Value_Asset = new Bonus_Value_Asset$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Bonus_Summary$Type extends MessageType<Bonus_Summary> {
    constructor() {
        super("mlmbox.types.Bonus.Summary", [
            { no: 1, name: "earned_value", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "values", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Bonus_Value }
        ]);
    }
    create(value?: PartialMessage<Bonus_Summary>): Bonus_Summary {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.earnedValue = "";
        message.values = [];
        if (value !== undefined)
            reflectionMergePartial<Bonus_Summary>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Bonus_Summary): Bonus_Summary {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string earned_value */ 1:
                    message.earnedValue = reader.string();
                    break;
                case /* repeated mlmbox.types.Bonus.Value values */ 2:
                    message.values.push(Bonus_Value.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Bonus_Summary, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string earned_value = 1; */
        if (message.earnedValue !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.earnedValue);
        /* repeated mlmbox.types.Bonus.Value values = 2; */
        for (let i = 0; i < message.values.length; i++)
            Bonus_Value.internalBinaryWrite(message.values[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Bonus.Summary
 */
export const Bonus_Summary = new Bonus_Summary$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Bonus_Summary_Asset$Type extends MessageType<Bonus_Summary_Asset> {
    constructor() {
        super("mlmbox.types.Bonus.Summary.Asset", [
            { no: 1, name: "asset_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "summary", kind: "message", T: () => Bonus_Summary }
        ]);
    }
    create(value?: PartialMessage<Bonus_Summary_Asset>): Bonus_Summary_Asset {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.assetId = 0;
        if (value !== undefined)
            reflectionMergePartial<Bonus_Summary_Asset>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Bonus_Summary_Asset): Bonus_Summary_Asset {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 asset_id */ 1:
                    message.assetId = reader.uint32();
                    break;
                case /* mlmbox.types.Bonus.Summary summary */ 2:
                    message.summary = Bonus_Summary.internalBinaryRead(reader, reader.uint32(), options, message.summary);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Bonus_Summary_Asset, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 asset_id = 1; */
        if (message.assetId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.assetId);
        /* mlmbox.types.Bonus.Summary summary = 2; */
        if (message.summary)
            Bonus_Summary.internalBinaryWrite(message.summary, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Bonus.Summary.Asset
 */
export const Bonus_Summary_Asset = new Bonus_Summary_Asset$Type();
